import { render, staticRenderFns } from "./ReturnOrder.vue?vue&type=template&id=d2f54966&"
import script from "./ReturnOrder.vue?vue&type=script&lang=js&"
export * from "./ReturnOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QField,QSelect,QItem,QItemSection,QBtn,QTable,QTr,QTh,QCheckbox,QTd,QInput,QDialog,QCard,QCardSection,QCardActions,QSpace,QChip,QTooltip,QAvatar,QSeparator,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QField,QSelect,QItem,QItemSection,QBtn,QTable,QTr,QTh,QCheckbox,QTd,QInput,QDialog,QCard,QCardSection,QCardActions,QSpace,QChip,QTooltip,QAvatar,QSeparator})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
